import React from 'react';

const Properties = () => {
  return (
    <div className="properties-page">
      <header 
        className="properties-header" 
        style={{ padding: '2rem 1rem', textAlign: 'center' }}
      >
        <h1 className="title" style={{ color: '#0d4157' }}>Properties</h1>
        <p className="subtitle" style={{ color: '#646569' }}>
          Explore our exclusive portfolio of Kenyan properties.
        </p>
      </header>
      <main 
        className="properties-main" 
        style={{ padding: '0 1rem', marginBottom: '2rem' }}
      >
        <div 
          className="properties-grid" 
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}
        >
          {/* Property Card 1 */}
          <div 
            className="property-card" 
            style={{ 
              border: '1px solid #eee', 
              borderRadius: '8px', 
              overflow: 'hidden', 
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)' 
            }}
          >
            <img 
              src="https://source.unsplash.com/random/400x300/?nairobi+house" 
              alt="Modern Nairobi Home" 
              className="property-image" 
              style={{ width: '100%', height: 'auto' }} 
            />
            <div className="property-info" style={{ padding: '1rem' }}>
              <h2 
                className="property-title" 
                style={{ color: '#0d4157', margin: 0 }}
              >
                Modern Nairobi Home
              </h2>
              <p 
                className="property-location" 
                style={{ color: '#646569', margin: '0.5rem 0' }}
              >
                Nairobi, Kenya
              </p>
              <p 
                className="property-price" 
                style={{ color: '#000000', fontWeight: 'bold' }}
              >
                KES 120,000,000
              </p>
            </div>
          </div>

          {/* Property Card 2 */}
          <div 
            className="property-card" 
            style={{ 
              border: '1px solid #eee', 
              borderRadius: '8px', 
              overflow: 'hidden', 
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)' 
            }}
          >
            <img 
              src="https://source.unsplash.com/random/400x300/?nairobi+apartment" 
              alt="Urban Apartment" 
              className="property-image" 
              style={{ width: '100%', height: 'auto' }} 
            />
            <div className="property-info" style={{ padding: '1rem' }}>
              <h2 
                className="property-title" 
                style={{ color: '#0d4157', margin: 0 }}
              >
                Urban Apartment
              </h2>
              <p 
                className="property-location" 
                style={{ color: '#646569', margin: '0.5rem 0' }}
              >
                Nairobi, Kenya
              </p>
              <p 
                className="property-price" 
                style={{ color: '#000000', fontWeight: 'bold' }}
              >
                KES 85,000,000
              </p>
            </div>
          </div>

          {/* Property Card 3 */}
          <div 
            className="property-card" 
            style={{ 
              border: '1px solid #eee', 
              borderRadius: '8px', 
              overflow: 'hidden', 
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)' 
            }}
          >
            <img 
              src="https://source.unsplash.com/random/400x300/?mombasa+villa" 
              alt="Luxury Villa" 
              className="property-image" 
              style={{ width: '100%', height: 'auto' }} 
            />
            <div className="property-info" style={{ padding: '1rem' }}>
              <h2 
                className="property-title" 
                style={{ color: '#0d4157', margin: 0 }}
              >
                Luxury Villa
              </h2>
              <p 
                className="property-location" 
                style={{ color: '#646569', margin: '0.5rem 0' }}
              >
                Mombasa, Kenya
              </p>
              <p 
                className="property-price" 
                style={{ color: '#000000', fontWeight: 'bold' }}
              >
                KES 250,000,000
              </p>
            </div>
          </div>
          {/* Add additional property cards as needed */}
        </div>
      </main>
    </div>
  );
};

export default Properties;
